module.exports = {"FILTER":{"BUTTON":{"SEARCH":"Cerca","RESET":"Reset","SHOW":"Mostra","HIDE":"Nascondi"}}}


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/app/core/translate/translations/it/filter.json
// module id = 729
// module chunks = 0